import { commonData, ProjectData, ProjectResponse } from '@app/shared/interfaces/hiring-manager.model';
import { dropdownValues } from '@app/shared/interfaces/common.model';
import { VendorDetails } from '@app/shared/interfaces/vendor.model';

export const getVendorOptions = (vendorRes: VendorDetails[]): dropdownValues[] => {
  if (!Array.isArray(vendorRes)) return [];

  return sortDropdownValues(
    vendorRes
      .filter((item: commonData) => item?.name && item.name !== 'null')
      .map((item: commonData) => ({
        label: item.name,
        value: item.name,
      }))
  );
};

export const getProjectOptions = (projects: ProjectResponse): dropdownValues[] => {
  if (!projects?.data?.project) return [];

  return projects.data.project
    .filter((item: ProjectData) => item?.name && item.name !== null)
    .map((item: ProjectData) => ({
      label: item.name,
      value: item.id,
    }));
};

export function sortDropdownValues(values: dropdownValues[]): dropdownValues[] {
  if (!Array.isArray(values)) return [];
  return values.sort((a, b) => (a.label ?? '').localeCompare(b.label ?? ''));
}
